<template>
  <div id="app" class="">
  <!-- <NavBar v-bind:links="['About', 'Contact','Donate']"/> -->
  <Header />
  <Footer />

  </div>
</template>

<script>
import Header from './components/Header.vue';
// import NavBar from './components/NavBar.vue';
import Footer from './components/Footer.vue';
// import About from './components/About.vue';
// import Features from './components/Features.vue';
// import Roadmap from './components/Roadmap.vue';
// import Team from './components/Team.vue';
export default {
  name: 'App',
  components: {
    Header,
    // NavBar,
    Footer,
    // About,
    // Features,
    // Roadmap,
    // Team
  }
}
</script>